

























































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import {
  getEquipmentUrl,
  getStockNumberFromUri,
  textTruncate,
} from "../../models";

import { db } from "../../db";
import AppVideo from "@/components/app-video.vue";
import { MetaInfo } from "vue-meta";
import AppPrintReport from "@/components/app-print-report.vue";

interface Spec {
  text: string;
  value: string;
}

@Component({
  components: { AppPrintReport, AppVideo },
  metaInfo(): MetaInfo {
    const self = (this as unknown) as InventoryEquipment;
    return {
      title: self.pageTitle,
      meta: [
        {
          name: "description",
          content: self.pageDescription,
          vmid: "description",
        },
        {
          name: "twitter:card",
          content: `${self.pageTitle}\n${self.pageDescription}`,
        },
        { name: "og:description", content: self.pageDescription },
        { name: "og:title", content: self.pageTitle },
        { name: "og:type", content: "article" },
        { name: "og:url", content: self.pageUrl },
        { name: "og:image", content: self.pageImageUrl },
      ],
    };
  },
})
export default class InventoryEquipment extends Vue {
  @Getter inventory;
  @Getter admin;

  private item: any = null;
  private images: any[] = [];
  private imagesBound = false;
  private selectedImageIndex = 0;

  private breadcrumbs: any[] = [
    { text: "Inventory", disabled: false, href: "/" },
  ];

  get specs(): Spec[] {
    return [
      { text: "Year", value: this.item.year },
      { text: "Make", value: this.item.make },
      { text: "Model", value: this.item.model },
      // {text: 'Vin', value: this.item.vin},
      { text: "Series", value: this.item.series },
      { text: "GVWR", value: this.item.gvwr },
      { text: "GVWR Class", value: this.item.gvwrClass },
      { text: "Engine Manufacturer", value: this.item.engineManufacturer },
      { text: "Engine Model", value: this.item.engineModel },
      { text: "Engine Liters", value: this.item.engineLiters },
      { text: "Engine HP", value: this.item.engineHP },
      { text: "Engine Cylinders", value: this.item.engineCylinders },
      { text: "Fuel Type", value: this.item.fuelType },
      {
        text: "Transmission Manufacturer",
        value: this.item.transmissionManufacturer,
      },
      { text: "Transmission", value: this.item.transmission },
      { text: "Drive Type", value: this.item.driveType },
      { text: "Rear Axle", value: this.item.rearAxle },
      { text: "Number Rear Axles", value: this.item.numberRearAxles },
      { text: "Front Tire Size", value: this.item.frontTireSize },
      { text: "Rear Tire Size", value: this.item.rearTireSize },
      { text: "Suspension", value: this.item.suspension },
      { text: "Rear End Ratio", value: this.item.rearEndRatio },
      { text: "Bed Dimensions", value: this.item.bedDimensions },
      { text: "Wheel Base", value: this.item.wheelBase },
      { text: "Odometer", value: Number(this.item.odometer).toLocaleString() },
      { text: "Brake Type", value: this.item.brakeType },
    ];
  }

  // Dialog
  private dialog = false;
  private imageResolution = 0;
  private stockNumber = "";
  async created() {
    const name = this.$route.params.name;
    this.stockNumber = getStockNumberFromUri(name);

    this.breadcrumbs = [
      { text: "Inventory", disabled: false, href: "/" },
    ];

    this.watchInventory();
  }

  @Watch("inventory", {immediate: true})
  watchInventory() {
      const list = this.inventory.filter( x => x.stockNumber == this.stockNumber);
      if( list.length > 0) {
        this.item = list[0];
        this.breadcrumbs.push({ text: this.item.name, disabled: true });

        this.bindImages();
      }
  }

  bindImages() {
    // get images
    if( !this.imagesBound) {
      this.$bind(
        "images",
        db.collection(`inventory/${this.item.id}/images`).orderBy("order", "asc")
      );
      this.imagesBound = true;
    }
  }

  get pageTitle() {
    if (this.item && this.item.name) {
      return textTruncate(this.item.name, 70);
    }
    return "";
  }

  get pageDescription() {
    if (this.item && this.item.comments) {
      return textTruncate(this.item.comments, 155);
    }
    return "";
  }

  get pageUrl() {
    if (this.item) {
      return `https://craigmyletrucks.com/inventory/${getEquipmentUrl(
        this.item
      )}`;
    }
    return "";
  }

  get pageImageUrl() {
    return `${this.item?.imageUrl}`;
  }

  setSelectedImage(index) {
    this.selectedImageIndex = index;
  }
}
